import { elementDef } from './elements/registry';

/**
 * A page layout drawn as a home page: the same 12-column grid the Spaces Builder previews, each element in its own place and size (the styles are .v3-sl-* in v3.css).
 * An element of a kind this version does not know is left out rather than breaking the page.
 */
export default function SpaceLayoutView({ user, layout }) {
  const elements = (layout && Array.isArray(layout.elements)) ? layout.elements : [];
  return (
    <div className="v3-sl-grid" data-testid="space-layout" data-layout-id={layout ? layout.id : undefined}>
      {elements.map((el) => {
        const def = elementDef(el.type);
        if (!def) return null;
        const Render = def.Render;
        return (
          <div key={el.id} className="v3-sl-cell" style={{ gridColumn: `${el.x + 1} / span ${el.w}`, gridRow: `${el.y + 1} / span ${el.h}` }} data-testid={`space-element-${el.id}`}>
            <Render user={user} props={el.props || {}} />
          </div>
        );
      })}
    </div>
  );
}
